<template>
	<div class="Dropdown" :class="{ open: open }">
		<div class="input-wrapper">
			<input
				ref="search"
				v-model="searchText"
				v-bind="$attrs"
				type="text"
				:class="customClass"
				@input="searchChanged"
				@keydown.down="down"
				@keydown.up="up"
				@keydown.enter="suggestionSelected(matches[highlightIndex])"
				@keydown.esc="setOpen(false)"
				@blur="setOpen(false)"
				@click="setOpen(true)"
			/>
			<a class="toggle" @mousedown.prevent="" @click="setOpen(!open)">
				<span class="arrow-up">
					<i class="el-icon-arrow-up" />
				</span>
				<span class="arrow-down">
					<i class="el-icon-arrow-down" />
				</span>
			</a>
		</div>
		<ul v-if="open" class="suggestion-list">
			<simplebar class="simplebar">
				<li
					v-for="(suggestion, index) in matches"
					:key="index"
					:class="{ active: index === highlightIndex }"
					@mousedown.prevent=""
					@click="suggestionSelected(suggestion)"
				>
					{{ suggestion[0] }}
				</li>
			</simplebar>
		</ul>
		<!-- <pre>{{ matches }}</pre> -->
		<!-- <select
      v-model="selectedOption"
      @input="event => { $emit('input', event.target.value) }"
    >
      <option
        v-for="(option, name) in options"
        :key="option"
        :value="option"
      >
        {{ name }}
      </option>
    </select> -->
	</div>
</template>

<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
export default {
	name: "Dropdown",
	components: {
		simplebar
	},
	inheritAttrs: false,
	props: {
		value: {
			type: [Object, Array, String, Number],
			default: null
		},
		options: {
			type: [Object, Array],
			required: true
		},
		customClass: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			searchText: "",
			open: false,
			highlightIndex: 0,
			lastSearchText: ""
		};
	},
	computed: {
		matches() {
			return Object.entries(this.options).filter(option => {
				var optionText = option[0].toUpperCase();
				return optionText.match(
					this.searchText.toUpperCase().replace(/\s+/g, ".+")
				);
			});
		}
	},
	mounted() {
		this.updateComponentWithValue(this.value);
	},
	methods: {
		up() {
			if (this.open) {
				if (this.highlightIndex > 0) {
					this.highlightIndex--;
				} else {
					this.setOpen(true);
				}
			}
		},
		down() {
			if (this.open) {
				if (this.highlightIndex < this.matches.length - 1) {
					this.highlightIndex++;
				} else {
					this.setOpen(true);
				}
			}
		},
		searchChanged() {
			if (!this.open) {
				this.open = true;
			}
			this.highlightIndex = 0;
		},
		updateComponentWithValue(newValue) {
			if (Object.values(this.options).indexOf(newValue) > -1) {
				// Find the matching text for the supplied option value
				for (var text in this.options) {
					if (this.options.hasOwnProperty(text)) {
						if (this.options[text] === newValue) {
							this.searchText = text;
						}
					}
				}
			}
		},
		suggestionSelected(suggestion) {
			this.open = false;
			this.searchText = suggestion[0];
			this.$emit("input", suggestion[1]);
		},
		setOpen(isOpen) {
			this.open = isOpen;
			if (this.open) {
				// this.$refs.search.focus();
				this.lastSearchText = this.searchText;
				this.searchText = "";
			} else if (this.searchText.trim() === "") {
				this.searchText = this.lastSearchText;
			}
		}
	}
};
</script>

<style scoped>
.simplebar {
	max-height: 200px;
}
.input-wrapper {
	display: flex;
	align-items: center;
	justify-content: space-between;
	border: 2px solid #888;
	border-radius: 4px;
	/* line-height: 40px; */
	padding: 0 8px;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	/* height: 100px; */
}
input {
	/* outline: violet; */
	/* outline-color: rgb(77, 144, 254);
	outline-style: auto; */
	/* line-height: 100%; */
	height: 100%;
	width: 100%;
	/* width: 100%; */
	/* padding: 8px; */
}
input:focus {
	outline: none;
}
.Dropdown {
	/* display: inline-block; */
	position: relative;
}
.suggestion-list {
	background-color: rgba(255, 255, 255, 0.95);
	border: 1px solid #ddd;
	list-style: none;
	display: block;
	margin: 0;
	padding: 0;
	width: 100%;
	overflow: hidden;
	position: absolute;
	top: 100%;
	left: 0;
	z-index: 2;
}
.suggestion-list li {
	padding: 8px;
}
.dropdown.open .suggestion-list {
	display: block;
}

.dropdown .suggestion-list {
	display: none;
}
.toggle .arrow-up {
	display: none;
}
.toggle {
	/* padding: 8px; */
}
.open .toggle .arrow-up {
	display: inline-block;
}

.open .toggle .arrow-down {
	display: none;
}
.suggestion-list li {
	cursor: pointer;
}

.suggestion-list li:hover {
	color: #fff;
	background-color: #ccc;
}
.active {
	color: #fff;
	background-color: #42b983;
}
</style>
